import {McbGridSearchOperator} from "./enum/mcb-grid-search-operator";

export class McbGridSearch {
  fieldName: string;
  operator: McbGridSearchOperator;
  values: any;


  constructor(fieldName: string, operator, values: any) {
    this.fieldName = fieldName;
    this.operator = operator;
    this.values = values;
  }
}
